const IsUserSignedIn = function(){
  return !!$('meta[name=current-username]').attr('content');
};

export default IsUserSignedIn;
